import QCXFinalNumericIntegerField from '../../final-numeric-integer-field/QCXFinalNumericIntegerField';
import type { AtributoCampoProps } from './types';

export default function ValorInteiroV2({ atributo, basePath, disabled = false }: AtributoCampoProps) {
  const name = `${basePath}.${atributo.codigo}.valor`;
  const label = `${atributo.descricaoCodigo} (${atributo.codigo})`;

  return (
    <QCXFinalNumericIntegerField
      id={atributo.codigo}
      name={name}
      label={label}
      maxLength={undefined}
      scale={7}
      disabled={disabled}
      allowNegative={false}
      required
    />
  );
}
